import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import { calls, fetchShadow } from '../general/redux/actions';
import AccountSecurityComponent from './account-security-component';

const mapStateToProps = (state: ApplicationState) => ({
  general: state.devices.detail.general,
  t: state.i18n.t,
  settings: state.devices.detail._settings
});

export default connect(mapStateToProps, {
  fetchShadow,
  calls
})(AccountSecurityComponent);
